import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.typed.uint32-array.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import { gunzipSync } from 'fflate';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import { CELL_SETS_IDS_LOADED, CELL_SETS_ERROR } from 'redux/actionTypes/cellSets';
import endUserMessages from 'utils/endUserMessages';
var decodeCellIds = function decodeCellIds(gzippedBuffer) {
  var ids = gunzipSync(new Uint8Array(gzippedBuffer));
  return new Set(new Uint32Array(ids.buffer, ids.byteOffset, ids.byteLength >>> 2));
};

/**
 * Stage 2 of the cell-sets load. Fetches the `{ setKey -> signedUrl }` map for the
 * materialized sets of the requested classes (all of them when `classKeys` is
 * null), fetches each gzipped uint32 blob, inflates + decodes it into a Set, and
 * merges them into the properties keyed by setKey. A single-class reload
 * (`classKeys = ['louvain']`) leaves the other classes' Sets untouched.
 */
var loadCellIds = function loadCellIds(experimentId) {
  var classKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var query, urlMap, cellIdsBySet, errorMessage;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            query = classKeys !== null && classKeys !== void 0 && classKeys.length ? "?classKeys=".concat(classKeys.join(',')) : '';
            _context2.next = 4;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets/cellIds").concat(query));
          case 4:
            urlMap = _context2.sent;
            cellIdsBySet = {};
            _context2.next = 8;
            return Promise.all(Object.entries(urlMap).map(/*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
                var _ref4, setKey, signedUrl, response;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _ref4 = _slicedToArray(_ref2, 2), setKey = _ref4[0], signedUrl = _ref4[1];
                      _context.next = 3;
                      return fetch(signedUrl);
                    case 3:
                      response = _context.sent;
                      if (response.ok) {
                        _context.next = 6;
                        break;
                      }
                      throw new Error("Error ".concat(response.status, " fetching cellIds blob for ").concat(setKey));
                    case 6:
                      _context.t0 = decodeCellIds;
                      _context.next = 9;
                      return response.arrayBuffer();
                    case 9:
                      _context.t1 = _context.sent;
                      cellIdsBySet[setKey] = (0, _context.t0)(_context.t1);
                    case 11:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }()));
          case 8:
            dispatch({
              type: CELL_SETS_IDS_LOADED,
              payload: {
                experimentId: experimentId,
                cellIdsBySet: cellIdsBySet
              }
            });
            _context2.next = 16;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](0);
            errorMessage = handleError(_context2.t0, endUserMessages.ERROR_FETCHING_CELL_SETS);
            console.error(_context2.t0);
            dispatch({
              type: CELL_SETS_ERROR,
              payload: {
                error: errorMessage
              }
            });
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 11]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadCellIds;